import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { authState } = useAuth();
  const { isLoggedIn, isLoading } = authState;

  // Wait for auth state to hydrate
  if (isLoading) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
